import __vue_component__$1 from '../Form/InlineEdit.vue.js';
import __vue_component__ from './NumberFloatRenderer.vue.js';

//
var script = {
  name: 'NumberFloatEditableRenderer',
  components: {
    NumberFloatRenderer: __vue_component__,
    InlineEdit: __vue_component__$1
  },
  props: {
    value: {
      type: Number,
      default: undefined
    },
    editable: {
      type: Boolean,
      default: true
    },
    placement: {
      type: String,
      default: 'right'
    }
  },
  methods: {
    onSaveRequested(...args) {
      this.$emit('save-requested', ...args);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/NumberFloatEditableRenderer.vue_rollup-plugin-vue=script.js